import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { GoogleLogin } from '@react-oauth/google';
import api from '../../utils/axios';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await api.post('/auth/login', { email, password });
            const data = response.data;
            localStorage.setItem('token', data.token);
            const decodedToken = jwtDecode(data.token);
            localStorage.setItem('userId', decodedToken.userId);

            // Fetch user profile
            const profileResponse = await api.get(`/user/${decodedToken.userId}/profile`);
            const profile = profileResponse.data;

            if (!profile.display_name) {
                navigate('/settings'); // Navigate to profile completion
            } else {
                if (decodedToken.role === 'admin') {
                    navigate('/admin');
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            setError('Invalid email or password');
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const loginResponse = await api.post('/auth/google', {
                idToken: credentialResponse.credential
            });
            handleAuthSuccess(loginResponse.data);
        } catch (error) {
            setError('Google login failed');
        }
    };

    const handleAuthSuccess = (data) => {
        // Store token
        localStorage.setItem('token', data.token);

        // Decode token and store userId
        const decodedToken = jwtDecode(data.token);
        localStorage.setItem('userId', decodedToken.userId);

        // Navigate based on role
        if (decodedToken.role === 'admin') {
            navigate('/admin');
        } else {
            navigate('/');
        }
    };

    return (
        <div className="auth-container">
            <form onSubmit={handleLogin} className="auth-form">
                <img src="/logo.svg" alt="SwavAI" className="auth-logo" />
                <h2>Login to SwavAI</h2>
                {error && <div className="error-message">{error}</div>}
                <div className="form-group">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                </div>
                <div className="form-group">
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                    />
                    <Link to="/forgot-password" className="forgot-password-link">
                        Forgot password?
                    </Link>
                </div>
                <button type="submit" className="auth-button">Login</button>
                <div className="auth-separator">
                    <span>or</span>
                </div>
                <div className="google-login-container">
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => setError('Google login failed')}
                        useOneTap
                    />
                </div>
                <div className="auth-links">
                    <p className="auth-link">
                        Don't have an account? <Link to="/signup">Sign up</Link>
                    </p>
                </div>
            </form>
        </div>
    );
};

export default Login;